module.exports = __webpack_public_path__ + "img/img03.ccbe3b23.jpg";